module.exports = __webpack_public_path__ + "media/images/distributions-018384a79e4abc63b86694f56dbd6965.svg";